import {AbstractVisualFeature} from '../../visual-feature.js';
import {Dialogs} from '../dialogs.js';

import {autoCashoutDialogConfig} from './auto-cashout.factory';

import PALETTE_SCHEMA from './auto-cashout.palette-schema.yaml';

class AutoCashoutFeature extends AbstractVisualFeature {
    get name() {
        return 'AutoCashout';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return autoCashoutDialogConfig(PALETTE);
    }
}

if (!GENBET_BASED) {
    // AutoCashout feature is only available in quantum backends
    new AutoCashoutFeature(Dialogs);
}
